import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {NullAsDefault} from 'views/Shared'
import _ from 'lodash'
import {SelectCountries} from '../../../Organization/Settings/SelectCountries'
import {useAppConfig} from '../../../../modules/local/AppConfigContext'
import {FilterStatusBar} from '../../../../components/Filters/FilterStatusBar'
import {DioceseTypeCodes} from '../../appFieldTypes'
import {Chip, SectionLabel} from './DirectoryFilterUI'

const defaultFilter = {
    keyword: undefined,
    diocese_typecd: undefined,
    country_id: undefined,
}

export const DirectoryDioceseFilter = ({
                                            value: filter = defaultFilter,
                                            onChange: setValues = NullAsDefault,
                                        }) => {
    const t = useTranslate()
    const {countries = []} = useAppConfig('countries')

    const handleChange = useCallback(
        (name, value) => setValues({...filter, [name]: value}),
        [filter]
    )

    const filteredParams = Object.entries(filter)
        .filter(([, value]) => value != null)
        .map(([key, value]) => {
            switch (key) {
                case 'country_id':
                    return {key, value, displayValue: _.find(countries, {id: Number(value)})?.common_name}
                case 'diocese_typecd':
                    return {key, value, displayValue: t(_.find(DioceseTypeCodes, {value})?.label)}
                default:
                    return {key, value, displayValue: value}
            }
        })

    return (
        <div className="flex flex-col gap-3">
            <FilterStatusBar
                filteredParams={filteredParams}
                onClear={() => setValues(defaultFilter)}
                onRemove={(param) => handleChange(param, undefined)}
            />

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('type')}</SectionLabel>
                <div className="flex flex-wrap gap-1.5">
                    {Object.values(DioceseTypeCodes).map((e) => (
                        <Chip
                            key={e.value}
                            active={filter?.diocese_typecd === e.value}
                            onClick={() => handleChange('diocese_typecd', filter?.diocese_typecd === e.value ? undefined : e.value)}>
                            {t(e.label)}
                        </Chip>
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('country')}</SectionLabel>
                <SelectCountries
                    value={filter?.country_id || undefined}
                    allowClear={true}
                    onChange={(value) => handleChange('country_id', Number(value) || undefined)}
                    placeholder={t('click to select')}
                />
            </div>
        </div>
    )
}

export default DirectoryDioceseFilter
